import axios from 'axios';

const PROTOCOL = window.location.protocol;
const HOST = (window.location.hostname === 'localhost') ? '127.0.0.1:3000' : window.location.hostname
const API_BASE_URL = PROTOCOL + "//" + HOST;

export const API = axios.create({
  baseURL: `${API_BASE_URL}/api`,
});